module.exports = __webpack_public_path__ + "img/Numberold.e63640cd.svg";